import { mapEnumToOptions } from '@abp/ng.core';

export enum TripStatus {
  Draft = 0,
  Dispatched = 1,
  Finished = 2,
  Planned = 3,
  OnRoute = 4,
  Canceled = 5,
  Confirmed = 6,
}

export const tripStatusOptions = mapEnumToOptions(TripStatus);
